// @see https://docs.google.com/document/d/1Tzpf6Z0tahdFu27C_QiIi02eAnVv4zA7S1VMS-UCbCs/edit#bookmark=id.nu6bs7k46ux7

const OutType = {
    Strikeout: { key: 'strikeout', name: 'Strikeout' },
    Pickoff: { key: 'pickoff', name: 'Pickoff' },
    FieldOut: { key: 'fieldOut', name: 'Field Out' },
    AirOut: { key: 'airOut', name: 'Air Out' },
    FlyOut: { key: 'flyOut', name: 'Fly Out' },
    LineOut: { key: 'lineOut', name: 'Line Out' },
    PopOut: { key: 'popOut', name: 'Pop Out' },
    GroundOut: { key: 'groundOut', name: 'Ground Out' },
    FoulOut: { key: 'foulOut', name: 'Foul Out' },
    CaughtStealing: { key: 'caughtStealing', name: 'Caught Stealing' },
    OnLastPlay: { key: 'onLastPlay', name: 'Out On Last Play' },
    OnAppeal: { key: 'onAppeal', name: 'Out On Appeal' },
    OffensiveInterference: { key: 'offensiveInterference', name: 'Offensive Interference' },
    BatterInterference: { key: 'batterInterference', name: 'Batter Interference' },
    InfieldFly: { key: 'infieldFly', name: 'Out On Infield Fly' },
    Sacrifice: { key: 'sacrifice', name: 'Sacrifice' },
    DidNotTag: { key: 'didNotTag', name: 'Did Not Tag' },
    DoubledOff: { key: 'doubledOff', name: 'Doubled Off' },
    CaughtTaggingUp: { key: 'caughtTaggingUp', name: 'Caught Tagging Up' },
    DoublePlay: { key: 'doublePlay', name: 'On Double Play' },
    TriplePlay: { key: 'triplePlay', name: 'On Triple Play' },
    ForceOut: { key: 'forceOut', name: 'Force Out' },
    Out: { key: 'out', name: 'Out' },
};

export default OutType;